import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipEventQueryCriteriaClass extends BaseCriteriaModel {
  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();
}

export class MembershipEventCriteriaModelQuery {
  query = '';

  constructor(MembershipEventCriteriaModel: MembershipEventQueryCriteriaClass) {

    if (!MembershipEventCriteriaModel) {
      return;
    }

    this.query += MembershipEventCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += MembershipEventCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += MembershipEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += MembershipEventCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += MembershipEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + MembershipEventCriteriaModel.status;
    this.query += '&orderBy=' + MembershipEventCriteriaModel.orderBy;
    this.query += '&order=' + MembershipEventCriteriaModel.order;
    this.query += '&offset=' + MembershipEventCriteriaModel.offset + '&limit=' + MembershipEventCriteriaModel.limit;
  }
}
